import React from 'react';
import styled from '@emotion/styled';
import { useIntl } from 'react-intl';
// theme
import { spacing, fontSizes, theme } from '../../utils';

// components
import { RecommendedIcon } from '../Icon';

const Text = styled.span`
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  margin-left: 5px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const RecommendedBadge: React.FC = () => {
  const i18n = useIntl();
  return (
    <Wrapper>
      <RecommendedIcon color={theme.palette.secondary.main} size="small" viewBox={17} />
      <Text>{i18n.formatMessage({ id: `generic.recommended` })}</Text>
    </Wrapper>
  );
};
